// Import react elements
import { useContext } from "react";

// Import context function
import { UserContext } from "global/context/UserContext";

// Import components
import TwoColumnList from "global/components/TwoColumnList";
import { Grid, GridItem } from "global/components/Grid";




const FulfilmentDetailsPopup = ({ isOpen, onClose, fulfilmentDetails, orderDetails, FulfilmentCostBreakdownTable }) => {

    //console.log(fulfilmentDetails);

    //const fulfilmentCurrency = fulfilmentDetails?.order?.currency || "GBP";

    // Get user data from context
    const { userData } = useContext(UserContext);



    // If isOpen is false return early (don't show the pop up)
    if (!isOpen) return null;


    
    // Else show the pop up
    return (

        <>

            <div className="popup-overlay">

                <div className="popup-container popup-container--medium">

                    {/* This is the modal header */}
                    <div className="popup__header">

                        {/* This is the title area */}
                        <div className="popup__headerLeft">

                            {/* This is the parent title */}
                            <h2 className="popup__title">

                                Fulfilment Details

                            </h2>

                            {/* This is the parent subtitle */}
                            <p className="popup__subtitle">

                                

                            </p>

                        </div>

                        {/* This is the header actions */}
                        <div className="popup__headerRight">

                            {/* This is the close button */}
                            <button type="button" className="popup__close" onClick={() => onClose?.()} title="Close">
                                🞬
                            </button>

                        </div>

                    </div>

                    <br/>

                    <div className="popup-content">

                        <>

                            {/* 
                            <Grid className={"popup_grid-container"}>

                                <OrderProgressTimeline
                                    formValues={fulfilmentDetails}                              
                                    CheckNullDate={CheckNullDate}
                                />

                            </Grid>
                            */}

                            <Grid className={"popup_grid-container"} >
                              
                                <GridItem>

                                    <div>

                                        <h3>Overview</h3>

                                        <TwoColumnList property={<label>Fulfilment ID:</label>} value={<input type="text" defaultValue={fulfilmentDetails.id || ""} disabled />} />   
                                        <TwoColumnList property={<label>Status</label>} value={<input type="text" defaultValue={fulfilmentDetails.status || ""} disabled />} />
                                        <TwoColumnList property={<label>Payment Method</label>} value={<input type="text" defaultValue={fulfilmentDetails.paymentmethod || ""} disabled />} />
                                        <TwoColumnList property={<label>Packed By</label>} value={<input type="text" defaultValue={fulfilmentDetails.batchid || ""} disabled />} />

                                        <br/>
                                        <h3>Order Notes</h3>
                                        <br />
                                        {/* <input type="text" defaultValue={fulfilmentDetails.order.order_notes || ""} placeholder="Order notes..." disabled /> */}
                                        <textarea name="order_notes" rows="2" cols="30" defaultValue={fulfilmentDetails.order.order_notes || ""} disabled></textarea>

                                    </div>

                                </GridItem>
     
                                <GridItem>

                                    <h3>Shipping Address</h3>
                                    <br />
                                    <TwoColumnList property={<label>Company Name</label>} value={<div className="two-column-list__text-string">{fulfilmentDetails.order.deliverycompanyname || ""}</div>} />
                                    <TwoColumnList property={<label>Customer Name</label>} value={<div className="two-column-list__text-string">{fulfilmentDetails.order.deliverycustname || ""}</div>} />
                                    <TwoColumnList property={<label>Address 1</label>} value={<div className="two-column-list__text-string">{fulfilmentDetails.order.deliveryaddr1 || ""}</div>} />
                                    <TwoColumnList property={<label>Address 2</label>} value={<div className="two-column-list__text-string">{fulfilmentDetails.order.deliveryaddr2 || ""}</div>} />
                                    <TwoColumnList property={<label>Address 3</label>} value={<div className="two-column-list__text-string">{fulfilmentDetails.order.deliveryaddr3 || ""}</div>} />
                                    <TwoColumnList property={<label>Town / City</label>} value={<div className="two-column-list__text-string">{fulfilmentDetails.order.deliveryaddr4 || ""}</div>} />
                                    <TwoColumnList property={<label>Postcode</label>} value={<div className="two-column-list__text-string">{fulfilmentDetails.order.deliverypostcode || ""}</div>} />
                                    <TwoColumnList property={<label>Country</label>} value={<div className="two-column-list__text-string">{fulfilmentDetails.order.deliverycountry || ""}</div>} />                                
                                    <TwoColumnList property={<label>Phone</label>} value={<div className="two-column-list__text-string">{fulfilmentDetails.order.deliverycontacttel || ""}</div>} />
                                    <TwoColumnList property={<label>Email</label>} value={<div className="two-column-list__text-string">{fulfilmentDetails.order.deliveryemail || ""}</div>} />

                                </GridItem>

                            </Grid>

                            <Grid className={"popup_grid-container"}>

                                <GridItem>

                                    <FulfilmentCostBreakdownTable costBreakdown={fulfilmentDetails.cost_breakdown} headerTitle="Fulfilment Cost Breakdown" userData={userData} orderItemsFromOrderDetails={orderDetails?.orderitems} />

                                </GridItem>

                            </Grid>
                           
                        </>

                    </div>

                </div>

            </div>

        </>

    )

}

export default FulfilmentDetailsPopup;